export default function (student) {
    if (student.first_name || student.last_name) {
        return `${student.last_name || ''} ${student.first_name || ''}`.trim();
    }

    return student.username;
}
